import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, ViewContainerRef, NgZone } from '@angular/core';
import { ShopboxTabComponent } from '@shared/components/component-schema/shopbox-tab-component.class';
import { ProgressChangesService } from '@shared/services/changes/progress-changes.service';
import { TranslateService } from '@shared/services/translate';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { UIChartComponent } from '../../../shopbox-chart/shopbox-chart.module';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Utilities } from '@shared/models/utilities/utilities.class';
import { APIFacadeService, NextInterface,
  ErrorInterface, CompleteInterface, API_TYPES, ERROR_TYPES, SharedChangesService } from '@shared/services';
import { ColorGenerator } from '@shared/models/color-generator/color-generator.class';
import { DialogsService } from '@shared/services/dialogs/dialogs.service';
import { ShopboxErrors } from '@shared/models/shopbox-errors/shopbox-errors.class';
import { CacheMapService } from '@shared/services/cache';
import { StoreBranches } from '@shared/models/store/store-branches.class';
import { CategoryGraph } from '@shared/models/category-graph/category-graph.class';
import { StaffGraph } from '@shared/models/staff-graph/staff-graph.class';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HtmlToPdf } from '@shared/models/html-to-pdf/html-to-pdf.class';
import { GraphDataFilters } from '@shared/models/graph/graph-filters.class';
import dayjs from 'dayjs';
import { OverviewToolbarComponent } from '../../components/overview-toolbar/overview-toolbar.component';
import { MatCard } from '@angular/material/card';
import { NgClass, UpperCasePipe, LowerCasePipe } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { CommandMenuComponent } from '../../components/command-menu/command-menu.component';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { ShopboxCheckboxComponent } from '../../../../shared/components/shopbox-checkbox/shopbox-checkbox.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ShopboxEmptyComponent } from '../../../../shared/components/shopbox-empty/shopbox-empty.component';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';

@Component({
    selector: 'shopbox-category-sales-tab',
    templateUrl: './category-sales-tab.component.html',
    styleUrls: ['./category-sales-tab.component.scss'],
    providers: [APIFacadeService],
    imports: [OverviewToolbarComponent, MatCard, MatTabGroup, MatTab, UIChartComponent, CommandMenuComponent, NgClass, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, ShopboxCheckboxComponent, MatIconButton, MatIcon, MatFormField, MatInput, FormsModule, ReactiveFormsModule, MatSuffix, MatSortHeader, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, ShopboxEmptyComponent, TranslatePipe, UpperCasePipe, LowerCasePipe]
})
export class CategorySalesTabComponent extends ShopboxTabComponent implements OnInit, OnDestroy {
  @ViewChild('spanVis', { static: false}) spanV: any;
  @ViewChild('chart', { static: false}) chart: UIChartComponent;
  @ViewChild('pChart', { static: false}) pChart: UIChartComponent;
  @ViewChild('pDChart', { static: false}) pDChart: UIChartComponent;
  @ViewChild('pWChart', { static: false}) pWChart: UIChartComponent;
  @ViewChild('pMChart', { static: false}) pMChart: UIChartComponent;

  branchList: any[] = [];
  tabs: any[];
  selectedDates = '';
  dataGraphOptions: any;
  options: any;

  widthSV: any = '100%';
  heightSV: any = 300;
  firstDay: number;
  secondDay: number;
  graphMode: number;
  idGroups: number[] = [];

  itemsDataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  displayedColumns = [
    'select',
    'name',
    'gross_sales',
    'items_sold',
    'net',
    'vat',
    'cost',
    'discounts',
    'revenue_margin'
  ];
  isEmpty = false;
  shownDate: string;
  byDay = false;
  byHours = false;
  byWeek = false;
  byMonth = false;
  customSelected = false;
  currentDate = '0';
  chartView = false;

  activeComponentSubject: Subject<any> = new Subject();
  currentStore: any;
  dateStart: number;
  dateEnd: number;
  typeSelector = 1;
  selectGraphIndex = 0;
  iconOpend = 'keyboard_arrow_down';
  iconClosed = 'keyboard_arrow_up';
  openedIdStaff: number[] = [];
  selectedTag: number;
  tagSearch: UntypedFormControl = new UntypedFormControl();

  isDownloadable = true;
  downloadProgress = false;
  isUpdateable = true;
  isFilterable = true;
  touch = new Utilities().isMobileDevice();
  menuControl: UntypedFormControl = new UntypedFormControl();
  setMenuValue: number;
  preSelectedDateRange: GraphDataFilters = GraphDataFilters.This_week;

  constructor(
    public _translate: TranslateService,
    private _changeDetectRef: ChangeDetectorRef,
    private apiSrv: APIFacadeService,
    private dialogSrv: DialogsService,
    private viewRef: ViewContainerRef,
    private cacheSrv: CacheMapService,
    private changeSimple: SharedChangesService,
    private zone: NgZone,
    public progressChange: ProgressChangesService,
    // private _ga: GaService
  ) {
    super(_translate);
    this.subscribeToApi();
  }

  ngOnInit() {
    if (this.viewPermission) {
      this.currentCurrency =
        this.apiSrv.shopboxApiService.graphService.getCurrency() || 'DKK';
      this.activeComponentPerResize();
      this.init();
      this.refreshTrans();
      this.searchChanges();
      this.menuChanges();
    }
  }

  searchChanges() {
    const tagSearchChanges = this.tagSearch.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(1000)
    ).subscribe((term) => {
      term = new Utilities().trimRightAndLeft(term);
      this.getData(this.currentStore, this.dateStart, this.dateEnd, this.graphMode, term);
    });
    this.apiSrv.subscriptionList.add(tagSearchChanges);
  }

  menuChanges() {
    const menuChangesVar = this.menuControl.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(500)
    ).subscribe((index) => {
      switch (index) {
        case 0:
            this.selectAllTags();
          break;
        case 1:
          this.selectNone();
          break;
        case 2:
          this.selectFirst5();
          break;
      }
    });
    this.apiSrv.subscriptionList.add(menuChangesVar);
  }


  init() {
    this.setDataGraph();
    this.branchList = [];
    this.setChartDate();
    this.resetChart();
  }

  downloadPdf() {
    const htmlToPdf = new HtmlToPdf();
    htmlToPdf.doneEvent.subscribe((res) => {
      this.changeProgress(false, this._changeDetectRef);
    });

    this.zone.runOutsideAngular(() => {
      this.changeProgress(true, this._changeDetectRef);
      htmlToPdf.createCanvasFromId('dashboard', 'category-sales');
      // this._ga.sendEvent('Dashboard category sales', 'Download', 'Download Dashboard category sales as PDF');
    });
  }

  setChartDate() {
    this.byDay = false;
    this.byHours = false;
    this.byWeek = false;
    this.customSelected = false;
    this.currentDate = '0';
    this.changeProgress(false, this._changeDetectRef);
  }

  getSelectedDates(value: string) {
    this.shownDate = value;
  }

  currencyWatch() {
    this.changeSimple.currentCurrencyChange.subscribe(
      (res: any) => {
        if (res) {
          this.currentCurrency = res;
          this._changeDetectRef.markForCheck();
        }
      }
    );
  }

  refreshTrans() {
    const translateChanges = this._translate.onLangChanged.subscribe(() => {
      this._changeDetectRef.markForCheck();
    });
    this.apiSrv.subscriptionList.add(translateChanges);
  }

  subscribeToApi() {
    this.apiSrv.subscribeToApi(this._changeDetectRef, 1000);
    this.apiSrv.nextEmit.subscribe((res: NextInterface) => {
      this.nextFn(res.res, res.apiType);
    });
    this.apiSrv.errorEmit.subscribe((res: ErrorInterface) => {
      this.errorFn(res.error, res.errorType);
    });
    this.apiSrv.completeEmit.subscribe((res: CompleteInterface) => {
      this.completeFn(res.apiType);
    });

  }

  nextFn(res: any, type: API_TYPES) {
    if (type === API_TYPES.GET_BRANCHES) {
      if (res && res.data) {
        const source = [];
        res.data.forEach(
          (element: any) => {
            const store = new StoreBranches(element);
            source.push(store);
          }
        );
        this.branchList = source;
      }
    } else if (type === API_TYPES.GET_CATEGORY_TABLE_COMPARE) {
      this.setTableItems(res);
      this.chartView = false;
    } else if (type === API_TYPES.GET_CATEGORY_GRAPH) {
      this.setGraphData(res);
    }
  }

  errorFn(error: any, type: ERROR_TYPES) {
    if (type === ERROR_TYPES.NORMAL) {
      this.dialogSrv.toast(error, this.viewRef, 3200, true);
    } else if (type === ERROR_TYPES.FORM) {
      const handle = new ShopboxErrors(error);
      if (handle.generalMessage) {
        this.dialogSrv.toast(handle.generalMessage, this.viewRef, 3200, true);
      } else {
        if (handle.allMessages[0]) {
          this.dialogSrv.toast(handle.allMessages[0], this.viewRef, 3200, true);
        }
      }
    }
    this.changeProgress(false, this._changeDetectRef);
  }

  completeFn(type: API_TYPES) {
    switch (type) {
      case API_TYPES.GET_CATEGORY_TABLE_COMPARE:
          if (this.idGroups.length > 0) {
            // this.updateData();
          } else {
            this.resetAll();
          }
          this.predefinedItems();
          this.changeProgress(false, this._changeDetectRef);
      break;

      default:
          this.changeProgress(false, this._changeDetectRef);
        break;
    }
  }

  setTableItems(res: any) {
    if (res && Array.isArray(res)) {
      const sources = [];
      res.forEach((element: any, index: number) => {
        if (this.typeSelector === 2) {
          if (element['tag_uid']) {
            const tag = new CategoryGraph(element);
            tag['backgroundColor'] = new ColorGenerator().getFixedColor(index);
            if (tag['staff'] && tag['staffId']) {
              const staff = new StaffGraph(element);
              staff['backgroundColor'] = new ColorGenerator().getFixedColor(index);
              sources.push(staff);
            } else {
              sources.push(tag);
            }
          }
        } else {
          if (element['tag_uid']) {
            const tag = new CategoryGraph(element);
            tag['backgroundColor'] = new ColorGenerator().getFixedColor(index);
            sources.push(tag);
          }
        }
      });
      this.refreshTable(sources);
    }
  }

  predefinedItems() {
    if (this.itemsDataSource.data.length > 0) {
      if (this.idGroups.length > 0) {
        const ids = [];
        this.idGroups.forEach((element) => {
          this.itemsDataSource.data.forEach((item) => {
            if (element === item.uid) {
              ids.push(element);
            }
          });
        });
        this.resetAll();
        this.idGroups = ids;
        this.resetChart();
      } else {
        this.setMenuValue = 2;
      }
      this.changeProgress(false, this._changeDetectRef);
    }
  }

  setGraphData(res: any) {
    if (res) {
      this.dataGraphOptions.datasets = [];
      let labelsBuilt = false;

      for (const i in res) {
        if (res[i] && Array.isArray(res[i])) {
          // Build labels from first dataset (Chart.js v4: use labels array + simple y-value data)
          if (!labelsBuilt) {
            this.dataGraphOptions.labels = res[i].map((element: any) => {
              const x = element['x'];
              // Hours (0–23) are numeric — do not parse as Date (new Date(9) → 01.01.1970)
              if (x != null && x !== '' && Number.isFinite(Number(x))) {
                return Number(x);
              }
              if (typeof x === 'string' && Number.isFinite(Date.parse(x))) {
                return this.formatDate(new Date(x).toString(), '.', true, false);
              }
              return x;
            });
            labelsBuilt = true;
          }

          // Extract y values only (matches labels by index)
          const yValues = res[i].map((element: any) => element['y']);

          const color = this.getBackgroundColor(Number(i));
          this.dataGraphOptions.datasets.push({
            fill: true,
            data: yValues,
            borderWidth: 2,
            borderColor: color,
            backgroundColor: 'rgba(225, 225, 225, 0)',
            pointBackgroundColor: color,
            pointBorderColor: color,
            hidden: false,
            type: 'line',
            label: this.getNameWithId(Number(i))
          });
        }
      }
      this.chartView = true;
      this.widthSV = this.spanV.nativeElement.clientWidth;
      this.heightSV = this.spanV.nativeElement.clientHeight - 80;
      this.updateChart();
      this.changeProgress(false, this._changeDetectRef);
    }
  }

  getNameWithId(id: number) {
    const index = this.itemsDataSource.data.findIndex(element => element['uid'] === id);
    return index !== -1 ? this.itemsDataSource.data[index]['name'] : '';
  }

  isSelectedItem(id: number) {
    return this.idGroups.indexOf(id) !== -1;
  }

  updateChart() {
    setTimeout(() => {
      if (this.pChart) {
        this.byHours = true;
        this.pChart.width = this.widthSV;
        this.pChart.height = this.heightSV;
        this.pChart.reinit();
      }
      if (this.pDChart) {
        this.byDay = true;
        this.pDChart.width = this.widthSV;
        this.pDChart.height = this.heightSV;
        this.pDChart.reinit();
      }
      if (this.pWChart) {
        this.byWeek = true;
        this.pWChart.width = this.widthSV;
        this.pWChart.height = this.heightSV;
        this.pWChart.reinit();
      }
      if (this.pMChart) {
        this.byMonth = true;
        this.pMChart.width = this.widthSV;
        this.pMChart.height = this.heightSV;
        this.pMChart.reinit();
      }
      this._changeDetectRef.markForCheck();
    }, 300);
  }

  getBackgroundColor(id: number): string {
    if (this.typeSelector === 2) {
      const index = this.itemsDataSource.data.findIndex(element => (element.uid === id) && (element['tagId'] === this.selectedTag));
      return index !== -1 ? this.itemsDataSource.data[index].backgroundColor : '';
    } else {
      const index = this.itemsDataSource.data.findIndex(element => element.uid === id);
      return index !== -1 ? this.itemsDataSource.data[index].backgroundColor : '';
    }
  }

  refreshTable(data: CategoryGraph[]) {
    this.itemsDataSource = new MatTableDataSource(data);
    this._changeDetectRef.markForCheck();
  }

  setDataGraphOptions() {
    this.dataGraphOptions = {
      labels: [],
      datasets: []
    };
  }

  setGraphOptions() {
    const currency = this.currentCurrency;
    this.options = {
      elements: {
        line: {
            tension: 0 // disables bezier curves
        }
      },
      animation: {
        duration: 500
      },
      plugins: {
        legend: {
          display: false,
          position: 'bottom',
        },
        tooltip: {
          enabled: true,
          mode: 'nearest',
          intersect: true,
          titleColor: 'rgba(0,0,0,0.7)',
          bodyColor: 'rgba(0,0,0,0.7)',
          backgroundColor: 'rgba(255,255,255,1)',
          borderColor: 'rgba(0,0,0,0.1)',
          borderWidth: 1,
          cornerRadius: 0,
          caretSize: 0,
          callbacks: {
            label(context: any) {
              let label = context.dataset.label || '';

              if (label) {
                label += ': ';
              }

              const title = label + new Utilities().formatMoney(context.parsed.y, currency) +
                ' ' + currency;
              return title;
            },
          },
        },
      },
      scales: {
        x: {
          display: true,
          grid: {
            display: true
          }
        },
        y: {
          display: true,
          beginAtZero: true,
          grid: {
            display: true
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false
    };
  }

  setDataGraph() {
    this.setDataGraphOptions();
    this.setGraphOptions();
  }

  resetAll() {
    this.selectedTag = null;
    this.openedIdStaff = [];
    this.chartView = false;
    this.idGroups = [];
    this.setMenuValue = undefined;
  }


  /**
   * getBranches
   * @function
   * @description get all stores
   */
  private getBranches() {
    const branchSub = this.apiSrv.shopboxApiService.branchService.getBranches();
    this.apiSrv.apiType = API_TYPES.GET_BRANCHES;
    this.apiSrv.errorType = ERROR_TYPES.NORMAL;
    this.apiSrv.apiSubject.next(branchSub);
  }

  /**
  * selectCustomDate
  * @function
  * @description get Graph in custom date
  */
  selectCustomDate(event) {
    this.byDay = false;
    this.byHours = false;
    this.byWeek = false;
    this.byMonth = false;
    if (event) {
      let start: any = event.begin;
      let end: any = event.end;
      if (end) {
        const num = dayjs(end).diff(dayjs(start), 'day');
        if (Math.abs(num) === 0) {
          this.byHours = true;
          this.byMonth = false;
          this.byDay = false;
          this.graphMode = 3;
        } else if (Math.abs(num) < 31) {
          this.byDay = true;
          this.byWeek = false;
          this.byMonth = false;
          this.graphMode = 2;
        } else if (Math.abs(num) > 31 && Math.abs(num) < 90) {
          this.byWeek = true;
          this.byDay = false;
          this.graphMode = 1;
        } else {
          this.byWeek = false;
          this.byDay = false;
          this.byMonth = true;
          this.graphMode = 0;
        }
        start = this.formatDate(start, null, false, true);
        end = this.formatDate(end, null, false, true);
      }
      let start_date, end_date;
      if (event.begin && event.end) {
        if (start < end) {
          start_date = start;
          end_date = end;
        } else {
          start_date = end;
          end_date = start;
        }
      } else {
        start_date = start;
        end_date = end;
      }
      this.firstDay = start_date;
      this.secondDay = end_date;
      const data = {} as any;
      data['index'] = 0;
      // this._ga.sendEvent('Category Sales Date Picker', 'Range', this.firstDay + ' ' + this.secondDay);
      if (start === end) {
        this.getSelectedDates(this.formatDate(event.begin, '.', true, false));
      } else {
        this.getSelectedDates(this.formatDate(event.begin, '.', true, false) + ' - ' + this.formatDate(event.end, '.', true, false));
      }
      this.getData(this.currentStore, this.firstDay, this.secondDay, this.graphMode);
    } else {
      this.changeProgress(false, this._changeDetectRef);
    }
  }

  formatDate(isoDate: string, divider: string, exist: boolean, reflect?: boolean): string {
    if (!reflect) {
      reflect = false;
    }
    const utility = new Utilities();
    return utility.formatDateReflact(isoDate, divider, exist, reflect);
  }


  storeAndDateChanged(changes: any) {
    this.changeProgress(true, this._changeDetectRef);
    const dates = changes.datePicker;
    const store = changes.store;
    this.typeSelector = Number(changes.staffMembers);
    this.storeChanged(store);
    this.selectCustomDate(dates);
  }

  storeChanged(currentStore: any) {
    this.currentStore = currentStore;
  }

  updateData() {
    this.chartView = true;
    this.cacheSrv.deleteAllCachesContain(CategoryGraph.URL);
    this.cacheSrv.deleteAllCachesContain(CategoryGraph.CategoryTableURL);
    this.getData(this.currentStore, this.dateStart, this.dateEnd, this.graphMode);
  }

  changeGraphTabs(event: any) {
    this.selectGraphIndex = event.index;
  }

  activeComponentPerResize() {
    const activeComponentChanges = this.activeComponentSubject
      .pipe(
        debounceTime(1500)
      )
      .subscribe(() => {
        if (this.branchList.length === 0) {
          this.getBranches();
        } else {
          this.getGraph();
        }
      });
      this.apiSrv.subscriptionList.add(activeComponentChanges);
  }

  /**
   * sortData
   * @function
   * @description Sort Data Table
   * @param {*} sort sort Object material
   */
  sortData(sort: any): void {
    let active = sort.active;
    const direction = sort.direction;
    if (direction !== 'asc') {
      active = '-' + active;
    }
    this.changeProgress(true, this._changeDetectRef);
    this.getData(this.currentStore, this.dateStart, this.dateEnd, this.graphMode, this.tagSearch.value, active);
  }

  getData(branchId: any, startDate?: number, endDate?: number, mode?: number, searchName?: string, sortItem?: string) {
    this.dateStart = startDate;
    this.dateEnd = endDate;
    const model = {
      start: startDate,
      end: endDate,
      type: this.typeSelector,
      is_category: 1
    };
    if (branchId && branchId !== 'null') {
      model['branch'] = branchId;
    }
    if (searchName) {
      model['name'] = searchName;
    }
    if (sortItem) {
      model['sort'] = sortItem;
    } else {
      model['sort'] = 'gross_sales';
    }
    const categoryGraphSub = this.apiSrv.shopboxApiService.categoryGraphService.getCategoryTable(model);
    this.apiSrv.apiType = API_TYPES.GET_CATEGORY_TABLE_COMPARE;
    this.apiSrv.errorType = ERROR_TYPES.NORMAL;
    this.apiSrv.apiSubject.next(categoryGraphSub);
  }

  getGraph() {
    const model = {
      start: this.firstDay,
      end: this.secondDay,
      mode: this.graphMode,
      is_category: 1
    };
    if (this.typeSelector === 2) {
      model['accounts'] = this.idGroups;
      model['uids'] = [this.selectedTag];
    } else {
      model['uids'] = this.idGroups;
    }
    if (this.currentStore && this.currentStore !== 'null') {
      model['branch'] = this.currentStore;
    }
    const categoryGraphSub = this.apiSrv.shopboxApiService.categoryGraphService.getGraph(model);
    this.apiSrv.apiType = API_TYPES.GET_CATEGORY_GRAPH;
    this.apiSrv.errorType = ERROR_TYPES.NORMAL;
    this.apiSrv.apiSubject.next(categoryGraphSub);
  }

  resetChart() {
    this.activeComponentSubject.next(true);
  }

  resize() {
    if (!this.activeProgress) {
      if (this.pDChart || this.pChart || this.pWChart) {
        this.resetChart();
      }
    }
  }

  updateModel(checked: boolean, id: number) {
    if (checked) {
      this.selectedIds(id);
    } else {
      this.unSelectedIds(id);
    }
    this.resetChart();
  }

  selectedIds(id: number) {
    this.idGroups.push(id);
  }

  unSelectedIds(id: number) {
    const i = this.idGroups.indexOf(id);
    this.idGroups.splice(i, 1);
  }


  trackItemFn(index: number, _item: any) {
    return index;
  }

  /**
   * openedStaff
   * @function
   * @description check staff id in the group to open it
   * @param {any} element [item to check]
   * @returns boolean
   */
  openedStaff(element: any): boolean {
    let result = true;
    if (element.type === 'staff') {
      const index = this.foundInViewStaff(element.tagId);
      result = index;
    }
    return result;
  }

  foundInViewStaff(uid: number) {
    return this.selectedTag === uid;
  }

  viewStaff(tag: any): void {
    if (this.selectedTag === tag.uid) {
      this.resetAll();
    } else {
      this.resetAll();
      this.selectedTag = tag.uid;
    }
  }

  selectAllTags() {
    this.resetAll();
    this.itemsDataSource.data.forEach((element) => {
      this.idGroups.push(element.uid);
    });
    this.resetChart();
  }

  selectNone() {
    this.resetAll();
    this.resetChart();
  }

  selectFirst5() {
    this.resetAll();
    this.itemsDataSource.data.forEach((element, index) => {
      if (index < 5) {
        this.idGroups.push(element.uid);
      }
    });
    this.resetChart();
  }

  menuClickHandler(menuIndex: number) {
    this.menuControl.setValue(menuIndex);
  }

  ngOnDestroy() {
    this.apiSrv.destroy();
  }

}
